// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GoLiveModalWidth{
  width:562px !important;  
}

.create-event-btns {
    display: flex;
    align-items: center;
    width: 190px;
    height: 54.29px;
    box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    color: #424242;
    background-color: #ffffff;
    padding: 14px;
    column-gap: 10px;
    margin-bottom: 16px;
    cursor: pointer
}

.next-btn,.next-btn-disabled {
    background: #68AD3F;
    box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    padding: 9px 11px;
    border: 1px solid #68AD3F;
}

.next-btn-disabled {
    opacity: 0.3 !important;
    font-weight: 400;
    font-size: 15px;
}

.select-label {
    font-weight: 500;
    font-size: 14px;
}

.select-label-error {
    color: red;
    font-weight: 500;
    font-size: 14px;
}

.input-control:focus-within label {
    color: #68ad3f;
}

.input-control:focus-within select {
    color: #68ad3f !important;
}

.input-box-org-select-error {
    width: 248px;
    border: 1px solid red;
    color: red !important;
}

.input-text-area-modal-length {
    width: 248px;
    text-align: right;
    color: #424242;
}

@media ((min-width: 0px) and (max-width:767px)) {
    .GoLiveModalWidth {
      width: 300px !important;
      font-size: 12px;
    }
  }
  @media ((min-width: 482px) and (max-width:767px)) {
    .GoLiveModalWidth {
      width: 470px !important;
      font-size: 12px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Components/Modals/OrganizerModal.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;MACE,uBAAuB;MACvB,eAAe;IACjB;EACF;EACA;IACE;MACE,uBAAuB;MACvB,eAAe;IACjB;EACF","sourcesContent":[".GoLiveModalWidth{\n  width:562px !important;  \n}\n\n.create-event-btns {\n    display: flex;\n    align-items: center;\n    width: 190px;\n    height: 54.29px;\n    box-shadow: 0px 15px 28px rgba(0, 0, 0, 0.05);\n    border-radius: 4px;\n    font-weight: 400;\n    font-size: 14px;\n    color: #424242;\n    background-color: #ffffff;\n    padding: 14px;\n    column-gap: 10px;\n    margin-bottom: 16px;\n    cursor: pointer\n}\n\n.next-btn,.next-btn-disabled {\n    background: #68AD3F;\n    box-shadow: 0px 2px 18px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    font-weight: 500;\n    font-size: 16px;\n    color: #FFFFFF;\n    padding: 9px 11px;\n    border: 1px solid #68AD3F;\n}\n\n.next-btn-disabled {\n    opacity: 0.3 !important;\n    font-weight: 400;\n    font-size: 15px;\n}\n\n.select-label {\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.select-label-error {\n    color: red;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.input-control:focus-within label {\n    color: #68ad3f;\n}\n\n.input-control:focus-within select {\n    color: #68ad3f !important;\n}\n\n.input-box-org-select-error {\n    width: 248px;\n    border: 1px solid red;\n    color: red !important;\n}\n\n.input-text-area-modal-length {\n    width: 248px;\n    text-align: right;\n    color: #424242;\n}\n\n@media ((min-width: 0px) and (max-width:767px)) {\n    .GoLiveModalWidth {\n      width: 300px !important;\n      font-size: 12px;\n    }\n  }\n  @media ((min-width: 482px) and (max-width:767px)) {\n    .GoLiveModalWidth {\n      width: 470px !important;\n      font-size: 12px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
